import { SERVICE } from '@ds/swymkit/tools'

import { commentFetch } from '~/services/fetch-comment'
import { swymFetch } from '~/services/fetch-swym'

import type { IRitual } from '~/entities/content/ritual/interfaces/ritual'

import { searchElementsExalead } from '~/features-shared/content/api/exalead-contents'
import { contentParser, contentsParser } from '~/features-shared/content/api/parser-contents'
import type { ISwymContent } from '~/features-shared/content/interfaces/swym-content'
import type { IFavorite } from '~/features-shared/favorites/interfaces/favorite'
import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

import type { SwymService } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

export function getRituals(): Promise<SwymResponse<IRitual[]>> {
  return swymFetch
    .get('/api/rituals')
    .json<SwymResponse<ISwymContent[]>>()
    .then(contentsParser<IRitual>)
}

export function getRitual(subject_uri: SUBJECT_6W_URI): Promise<SwymResponse<IRitual>> {
  return swymFetch
    .get(`/api/rituals/${subject_uri}`)
    .json<SwymResponse<ISwymContent>>()
    .then(contentParser<IRitual>)
}

export function getFavorites(): Promise<SwymResponse<IFavorite[]>> {
  return commentFetch
    .get('/api/favorites/type/ritual')
    .json()
}

export function removeFavorite(subject_uri: SUBJECT_6W_URI): Promise<SwymResponse<void>> {
  return commentFetch
    .delete(`/api/favorites/${subject_uri}/service_name/3DSwym/type/ritual`)
    .json()
}

export function addFavorite(subject_uri: SUBJECT_6W_URI, position: number) {
  return commentFetch
    .patch('/api/favorites', {
      json: {
        position,
        service_name: SERVICE.SWYM,
        subject_uri,
        type: 'ritual',
      },
    })
    .json<SwymResponse<IFavorite>>()
}

export function getRitualWhatsNew() {
  return swymFetch.get('api/rituals/whatsnew')
    .json()
}

export const RitualsSwymServices: SwymService<IRitual> = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll(params) {
    let url = `/api/rituals/whatsnew?page_size=${params.limit}&page_number=${params.page - 1}`
    if (params?.subject_uri) {
      if (params.afterDate)
        url = `/api/rituals/${params.subject_uri}/conferences?page_size=${params.limit}&page_number=${params.page - 1}&after=${params.afterDate}`
      else
        url = `/api/rituals/${params.subject_uri}/conferences?page_size=${params.limit}&page_number=${params.page - 1}`
    }

    const contentsMap = new Map<string, IRitual>()
    const response = await swymFetch
      .get(url)
      .json<SwymResponse<ISwymContent[]>>()

    contentsParser<IRitual>(response).result.forEach((el) => {
      delete el.updated_at // this is a partial response, remove updated at so the mergeContent will overwrite this data
      contentsMap.set(el.subject_uri, el)
    })

    const draftsQuery = [...contentsMap.keys()]
      .map(el => `"${el}"`)
      .join(' BOR ')

    const searchDraftsData = await searchElementsExalead(draftsQuery, true)
    searchDraftsData.forEach((el) => {
      contentsMap.set(el.subject_uri, { ...el, ...(contentsMap.get(el.subject_uri) as IRitual) })
    })

    return {
      data: [...contentsMap.values()],
      total: response.result.length,
    }
  },

}
